export default __webpack_public_path__ + "static/iso-cert-logo-7d29765f44c58bbe7f68a4f1dc72f5a4.svg";